import { z } from "zod";

import {
  CreateOfferDto,
  CreateOfferDtoSchema,
  OfferDtoSchema,
} from "../../../dtos/offers";

export const PostOfferRequestBodySchema = z.object({
  offer: CreateOfferDtoSchema,
});

export type PostOfferRequestBodyType = z.infer<
  typeof PostOfferRequestBodySchema
>;

export const PostOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type PostOfferResponseBodyType = z.infer<
  typeof PostOfferResponseBodySchema
>;
